const PassengersInfoSection = ({ passengers }) => {
  return (
    <div className=" md:w-[48%] w-full  bg-third rounded-3xl p-6 font-semibold flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h3 className="text-gray-400">Passengers Info:</h3>
      </div>
      {passengers?.length === 0 ? (
        <p className="text-gray-400">no data avilable</p>
      ) : (
        <div className="flex flex-col gap-3">
          {passengers?.map((el) => (
            <div
              key={el?.id}
              className="flex items-center justify-between border-b-4 border-fifth pb-3"
            >
              <div className="flex items-center gap-3">
                <div>
                  <h4 className="text-black">{el?.full_name}</h4>
                  <p className="text-xs text-black">{el?.phone}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PassengersInfoSection;
